import { useEffect, useRef } from "react";

// rellax
import Rellax from "rellax";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Otis Kit PRO components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/fbce-sanctuary-original.jpg";

// Membership page sections
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import DefaultFooter from "components/footers/DefaultFooter";
import PrayForMe from "pages/Ministries/sections/PrayForMe";
import MinistriesHeader from "pages/Ministries/sections/header";
import KindnessMinistiry from "pages/Ministries/sections/KindnessMinistry";
import Upward from "pages/Ministries/sections/Upward";
import GoodNewsClub from "pages/Ministries/sections/GoodNewsClub";

function MinistriesPage() {
  const headerRef = useRef(null);

  // Setting up rellax
  useEffect(() => {
    const parallax = new Rellax(headerRef.current, {
      speed: -6,
    });

    return () => parallax.destroy();
  }, []);

  return (
    <>
      <DefaultNavbar routes={routes} />
      <MKBox
        ref={headerRef}
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.9),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50% 75%",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            {" "}
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Ministries
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          // p: 2,
          // mx: { xs: 2, lg: 3 },
          mt: -14,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MinistriesHeader />
        <MKBox
          display="flex"
          flexDirection="row"
          justifyContent="space-around"
          style={{ flexWrap: "wrap" }}
        >
          <KindnessMinistiry />
          <PrayForMe />
          <Upward />
          <GoodNewsClub />
        </MKBox>
      </Card>
      <MKBox px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default MinistriesPage;
